import { useAppStore } from '../state/store';
import { IconInfo, IconLayers, IconLocate, IconRecenter } from './Icons';

/** Bottoni flottanti sulla mappa (posizione, heatmap ombra, info), stile Apple Maps. */
export function MapControls() {
  const plan = useAppStore((s) => s.plan);
  const heatmapOn = useAppStore((s) => s.heatmapOn);
  const heatmapLoading = useAppStore((s) => s.heatmapLoading);
  const toggleHeatmap = useAppStore((s) => s.toggleHeatmap);
  const setInfoOpen = useAppStore((s) => s.setInfoOpen);
  const setPoint = useAppStore((s) => s.setPoint);
  const setHint = useAppStore((s) => s.setHint);
  const navActive = useAppStore((s) => s.navActive);
  const followUser = useAppStore((s) => s.followUser);
  const setFollowUser = useAppStore((s) => s.setFollowUser);
  const a = useAppStore((s) => s.a);

  const locate = () => {
    if (navActive) {
      setFollowUser(true);
      return;
    }
    if (!('geolocation' in navigator)) {
      setHint('Il browser non espone la geolocalizzazione.');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const ll = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setPoint(a ? 'b' : 'a', ll, 'La mia posizione');
      },
      () => setHint('Non riesco a leggere la posizione: controlla i permessi del browser.'),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60_000 },
    );
  };

  return (
    <div className="map-controls">
      <button
        type="button"
        className={`map-btn${navActive && followUser ? ' map-btn--active' : ''}`}
        title={
          navActive
            ? 'Ricentra su di me'
            : a
              ? 'Arrivo: la mia posizione'
              : 'Partenza: la mia posizione'
        }
        aria-label="La mia posizione"
        onClick={locate}
      >
        {navActive ? <IconRecenter /> : <IconLocate />}
      </button>
      <button
        type="button"
        className={`map-btn${heatmapOn ? ' map-btn--active' : ''}`}
        title="Mostra l’ombra su tutte le strade dell’area"
        aria-label="Heatmap dell’ombra"
        aria-pressed={heatmapOn}
        onClick={() => {
          if (!plan) {
            setHint('Calcola prima un percorso: la heatmap mostra l’ombra dell’area scaricata.');
            return;
          }
          toggleHeatmap();
        }}
      >
        {heatmapLoading ? <span className="mini-spinner" /> : <IconLayers />}
      </button>
      <button
        type="button"
        className="map-btn"
        title="Come funziona"
        aria-label="Come funziona"
        onClick={() => setInfoOpen(true)}
      >
        <IconInfo />
      </button>
      {heatmapOn && (
        <div className="heat-legend material" aria-label="Legenda heatmap">
          <span>sole</span>
          <span className="heat-legend__bar" />
          <span>ombra</span>
        </div>
      )}
    </div>
  );
}
